import React, { useState } from 'react'
import axios from "axios";
import parentregisStyle from './ParentsRegisterPage.module.css'
import ParentsMainHeader from '../../components/MainHeader/ParentsMainHeader'
import { useMediaQuery } from 'react-responsive';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import ParentRegisterMobilStepOne from '../auth/ParentRegisterMobilStepOne'
import ParentRegisterMobilStepTwo from '../auth/ParentRegisterMobilStepTwo'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function ParentsRegisterPage() {

  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  // Define state for the current step
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  // Define total steps in the process
  const totalSteps = 2;

  // Handle the next step
  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle the previous step
  // const prevStep = () => {
  // if (currentStep > 1) {
  // setCurrentStep(currentStep - 1);
  // }
  // };

  // Handle the form submission
  const steppersubmit = () => {
    // Logic for form submission can go here
    setIsSubmitted(true);
    // console.log('Form submitted');
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    position: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const formatPhone = (value) => {
    if (!value) return "";

    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 3) return digits;
    if (digits.length <= 6)
      return `${digits.slice(0, 3)}-${digits.slice(3)}`;

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handlePhoneChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);

    setFormData((prev) => ({
      ...prev,
      phone: digitsOnly, // stored as 1234567890
    }));
  };

  // const handleFileChange = (e) => {
  //   setFormData(prev => ({ ...prev, image: e.target.files[0] }));
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_parent.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.status == 'success') {
        const pId = res.data.id;
        Swal.fire({
          title: "Thankyou you for your submission",
          text: "Thankyou for registering. Please check your email for login information.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then((data) => {
          navigate(`/ParentsProfilePage/${pId}`);
        });
      }
      else if (res.data.status == 'error') {
        Swal.fire({
          title: "Error!",
          text: res.data.message,
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }

      //alert(res.data.message);
    } catch (err) {
      console.error(err);
      alert("Registration failed");
    }
  };
  return (
    <>
      <ParentsMainHeader />
      {isMobile ? (
        <div className={parentregisStyle.mobilparentregisterpage}>
          <div className='container'>
            <div className='row'>
              <div className='col-xl-12'>
                <div className={parentregisStyle.mobilparentstepperWrapper}>
                  <div className={parentregisStyle.mobilparentstepperContent}>
                    {currentStep === 1 && <ParentRegisterMobilStepOne />}
                    {currentStep === 2 && <ParentRegisterMobilStepTwo />}
                  </div>
                  <div className={`${parentregisStyle.mobilparentstepperFooter} mb-5`}>

                    {/* <button onClick={prevStep} disabled={currentStep === 1}> Back </button> */}
                    {currentStep === totalSteps ? (
                      <button className={`${parentregisStyle.mobilparentsubmitStepper} btn btn-warning w-100`} onClick={steppersubmit} disabled={isSubmitted}>
                        {isSubmitted ? 'Submitted' : 'Submit'}
                      </button>
                    ) : (
                      <button className={`${parentregisStyle.mobilparentnextStepper} btn btn-warning w-100`} onClick={nextStep} disabled={currentStep === totalSteps}>
                        Next
                      </button>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={parentregisStyle.parentregisterpage}>
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-start">
              <div className="col-xl-8 col-xxl-8">
                <h3> Welcome! Sign up to Join! </h3>
                <div className={parentregisStyle.parentcationContent}>
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-3 justify-content-center">
                      <div className="col-xl-9 col-xxl-9">
                        <h6> Parent Information </h6>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}>First Name</label>
                            <input type="text" className={`${parentregisStyle.parentsInput} form-control`} name="firstName" onChange={handleChange} required />
                          </div>
                          <div className="col-md-6">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}>Last Name</label>
                            <input type="text" className={`${parentregisStyle.parentsInput} form-control`} name="lastName" onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}>Position</label>
                            <input type="text" className={`${parentregisStyle.parentsInput} form-control`} name="position" onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}>Email Address</label>
                            <input type="email" className={`${parentregisStyle.parentsInput} form-control`} name="email" onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}>Phone:</label>
                            <input type="text" className={`${parentregisStyle.parentsInput} form-control`} name="phone" value={formatPhone(formData.phone || "")} onChange={handlePhoneChange} maxLength={12} inputMode="numeric" required />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3">
                        <div className={parentregisStyle.parentsimageCircle}>
                          <div className={parentregisStyle.parentscircleEdit}>
                            <input
                              type="file"
                              id="publisherimageUploads"
                              className={parentregisStyle.parentsInputcircle}
                              name="image"
                              accept=".png, .jpg, .jpeg"
                              onChange={handleFileChange}
                            />
                            <label htmlFor="publisherimageUploads"></label>
                          </div>
                          <div className={parentregisStyle.parentscirclePreview}>
                            <div id="publisherimagePreview">
                              {previewImage && (
                                <img
                                  src={previewImage}
                                  alt="Preview"
                                  style={{ width: "100%", height: "auto", borderRadius: "50%" }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-xl-9 col-xxl-9">
                        <h6 className='pb-4'> Password </h6>
                        <div className="row">
                          <div className="mb-3">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}> Choose your password </label>
                            <div className={parentregisStyle.parentspasswordwrapper}>
                              <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${parentregisStyle.parentsInput} form-control`} name="password" onChange={handleChange} required />
                              <div className={parentregisStyle.parentstogglebutton} onClick={togglePasswordVisibility}>
                                {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3">
                            <label className={`${parentregisStyle.parentsLabel} form-label`}> Confirm your password </label>
                            <div className={parentregisStyle.parentspasswordwrapper}>
                              <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${parentregisStyle.parentsInput} form-control`} name="confirmPassword" onChange={handleChange} required />
                              <div className={parentregisStyle.parentstogglebutton} onClick={toggleCPasswordVisibility}>
                                {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3"></div>
                    </div>
                    <div className="row">
                      <div className="text-center mb-3 mt-4">
                        <button className={`${parentregisStyle.parentsubmitButton} btn btn-warning `}>SUBMIT</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>)}
    </>
  )
}
